<template>
  <div>
    <!--头部-->
    <HeaderForBeauty :showValue="3"></HeaderForBeauty>
    <!--banner end-->
    <div class="jqgk" style="background: rgba(227, 227, 227, 0.84)">
      <div class="contai" style="max-width: 1197px">
        <div class="top_tit" style="margin-top: 20px">
          <div
            style="
              height: 50px;
              width: 100%;
              text-align: left;
              line-height: 50px;
            "
          >
            <div class="beautytab">
              <div class="table-item" v-for="item in listCaiDan" :key="item.id">
                <span
                  :style="chooseValue == item.id ? styletable : mapStyle"
                  class="table-button"
                  @click="chooseTab(item)"
                  >{{ item.title }}</span
                >
              </div>
            </div>
          </div>

          <div
            v-if="pcshow"
            style="
              text-align: left;
              padding: 10px 60px 60px 60px;
              background-color: #fff;
              margin-top: 20px;
            "
          >
            <p style="color: #840207;font-size:20px">{{ title }}</p>
            <img :src="cover" alt="...." style="width: 77%; margin-left: 11.5%" />
            <div class="travel_con newtravel_con">
              <!-- <video-player
                class="video-player vjs-custom-skin radio"
                style="height: 100%"
                ref="videoPlayer"
                :playsinline="true"
                :options="playerOptions"
              ></video-player> -->
              <div style="width: 100%; margin-top: 30px">
                <!-- <aplayer :music="videoUpload.music"></aplayer> -->
                 <aplayer :music="audio[0]" :list="audio"  :showlrc="true"></aplayer>
              </div>
            </div>
          </div>

          <div v-if="!pcshow" style=" text-align: left; padding: 10px; background-color: #fff; margin-top: 20px; ">
            <p style="color: #840207">{{ title }}</p>
            <img :src="cover" alt="...." style="width: 100%" />

            <div>
              <div style="width: 100%; margin-top: 15px">
                 <aplayer :music="audio[0]" :list="audio"  :showlrc="true"></aplayer>
                <!-- <aplayer :music="videoUpload.music"></aplayer> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import aplayer from 'vue-aplayer'

import { getcnBeautyAudio } from '@/api/public'
import HeaderForBeauty from './headerforbeauty'
import Footer from './footer'
export default {
  components: { HeaderForBeauty, Footer, aplayer },
  data () {
    return {
      audio: [
        {
          title: '语音导赏',
          artist: '西樵山',
          url: 'https://xiqiaoshantour.com/static/voice/cn/a727c8db-771b-44d9-b264-50279063289d西樵山概况.mp3',
          pic: '',
          lrc: '[00:00.00] (,,•́ . •̀,,) 欢迎来到西樵山语音导赏'
        }
      ],
      cover: '',
      choseValue: 1,
      pcshow: false,
      styletable: {},
      mapStyle: {
        color: '#840207',
        background:
          'linear-gradient(270deg, rgba(132, 2, 7, 0.29), rgba(132, 2, 7, 0))'
      },
      videoUpload: {
        progress: false,
        progressPercent: 0,
        successPercent: 0,
        music: {
          title: '',
          author: ' ',
          url: '',
          lrc: '[00:00.00]lrc here\n[00:01.00]aplayer'
        }
      },
      dataList: [],
      listCaiDan: [],
      title: '',
      chooseValue: 1
    }
  },
  beforeCreate () {},
  created () {
    if (this._isMobile()) {
      this.pcshow = false
    } else {
      this.pcshow = true
    }
  },
  mounted () {
    this.init1()
  },

  methods: {
    // 选择菜单
    chooseTab (info) {
      console.log(document.getElementsByClassName('video-js'))
      this.chooseValue = info.id
      this.title = info.title
      this.init2()
    },
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    // 初始化工作
    init1 () {
      getcnBeautyAudio(this.title).then((response) => {
        this.listCaiDan = response.data
        // eslint-disable-next-line no-unused-expressions
        this.listCaiDan.length > 0 ? ((this.chooseValue = this.listCaiDan[0].id), (this.title = this.listCaiDan[0].title)) : ''
        this.init2()
      })
    },
    // 初始化内容获取
    init2 () {
      getcnBeautyAudio(this.title).then((response) => {
        // this.videoUpload = {
        //   progress: false,
        //   progressPercent: 0,
        //   successPercent: 0,
        //   music: {
        //     title: response.data[0].title,
        //     author: ' ',
        //     url: response.data[0].url,
        //     lrc: '[00:00.00]lrc here\n[00:01.00]aplayer'
        //   }
        // }
        // console.log('response:', response)
        this.audio = []
        var linshi = []
        this.cover = response.data[0].cover
        // console.log('response:', JSON.parse(response.data[0].url))
        var newData = JSON.parse(response.data[0].url)
        newData.forEach((item, index, arr) => {
          var newTitle = item.name
          var disLength = newTitle.length
          var showName = '西樵山'
          var showName2 = '西樵山'
          if (disLength > 36) {
            showName = newTitle.substring(36, disLength)
            showName2 = newTitle.substring(36, disLength - 4)
          }
          linshi.push(
            {
              title: showName,
              artist: ' ',
              url: item.url,
              pic: '',
              lrc: '[00:00.00]'
            }
          )
        })
        this.audio = linshi
        // console.log('response12:', this.audio)
      })
    },
    // 菜单选择
    tabSelect (e) {
      let value = e.target.dataset.index
      this.choseValue = value
    },
    // 详情()
    seeInfo (infoid) {
      this.$router.push({
        path: '/sceneryInfo',
        query: {
          id: infoid
        }
      })
    }
  }
}
</script>
<style>
.classNew {
  background: url("http://gangmao.oss-cn-shenzhen.aliyuncs.com/company/20200322/Home_mz_qbgd-vc-upload-1584880764648-2.png")
    no-repeat;
  background-size: 100%;
}
/* .radio .video-player{
  background:url(~@/assets/xqsimage/banner3.png)  no-repeat;
  background-size: 100%;
} */
.radio .video-js {
  background: url(~@/assets/xqsimage/banner3.png) no-repeat;
  background-size: 100%;
}
.titleShuXian {
  height: 48px;
  margin-top: 9px;
  width: 8px;
  background-color: #840207;
  float: left;
}
.titleFontEnglish {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 10px;
  padding-bottom: 15px;
}
.tra_tab {
  font-size: 28px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  width: 193px;
  height: 67px;
  text-align: center;
  line-height: 67px;
  cursor: pointer;
}
.tra_tab_mobile {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  padding: 10px;
}
.tra_tab_line_mobile {
  display: block;
  width: 100%;
  height: 2px;
  background: #840207;
  opacity: 0.1;
}
.tra_tab_line {
  display: block;
  width: 100%;
  height: 8px;
  background: #840207;
  opacity: 0.1;
}
.titleFontFortitle {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #840207;
  line-height: 36px;
  float: left;
  padding: 15px;
}
.sceneryImgSize {
  /* width: 542px;
  height: 359px; */
  /* width: 250px; */
  padding-right: 5px;
  height: 200px;
}
.sceneryFontSize {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  width: 270px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}
.showPicture {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}
.sceneryDescFontSize {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0 20px;
  margin-bottom: 20px;
  width: 270px;
  height: 60px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.sceneryBtn {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #ffffff;
  width: 126px;
  height: 44px;
  background: #840207;
  border: none;
  margin: 25px 0px 50px;
}

.beautytab {
  white-space: nowrap;
  height: 5rem;
  line-height: 1.466666666666667rem;
  font-size: 0.7rem;
  overflow-y: hidden;
  padding-top: 10px;
}
.beautytab .table-item {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: inline-block;
}
.beautytab .table-button {
  min-width: 61px;
  height: 30px;
  border-radius: 4px;
  background: #840207;
  border-radius: 4px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #fff5e0;
  cursor: pointer;
}
.newtravel_con {
  width: 840px !important;
}
.aplayer-pic{
  /* music.jpg */
  background-image: url('../assets/buchong/music.jpg')  !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BeautyAllOverForRadio.vue